// extracted by mini-css-extract-plugin
export default {"iconClose":"Login_iconClose__di3Lx"};